<div class="mt-18 d-flex justify-content-between align-items-center">
  <div class="flexRow">
    <div class="mr-md">
      <nz-select [(ngModel)]="managementDataDateType" class="mr-xs width-84">
        <nz-option [nzValue]="1" nzLabel="今日"></nz-option>
        <nz-option [nzValue]="2" nzLabel="历史"></nz-option>
      </nz-select>
      <nz-range-picker
        class="table-top-range-date2"
        [(ngModel)]="managementDataDate"
        [nzDisabledDate]="disabledDate"
        *ngIf="managementDataDateType == 2"
      ></nz-range-picker>
      <span class="text-gray1" *ngIf="managementDataDateType == 1">今日数据每2小时更新，上次更新时间{{ managementDataCreateTime }}</span>
    </div>
    <div class="">
      <label class="mr-xs">人员:</label>
      <nz-select [(ngModel)]="managementDataDataType" class="mr-xs width-84">
        <nz-option [nzValue]="1" nzLabel="猎头"></nz-option>
        <nz-option [nzValue]="2" nzLabel="面试官" *ngIf="type == 1"></nz-option>
      </nz-select>
      <nz-select
        *ngIf="managementDataDataType == 2"
        [(ngModel)]="managementDataDunfordId"
        nzShowSearch
        nzPlaceHolder="请选择面试官"
        class="width-236"
        (click)="managementDataDunfordShow = true"
        nzMode="multiple"
        nzMaxTagCount="2"
        [nzDropdownStyle]="{ display: 'none' }"
        (ngModelChange)="managementDataDunfordIdChange()"
        [nzMaxTagPlaceholder]="tagPlaceHolder5"
      >
        <nz-option *ngFor="let v of interviewerList" [nzValue]="v.employee_id" [nzLabel]="v.username"></nz-option>
      </nz-select>
      <ng-template #tagPlaceHolder5 let-selectedList>+{{ selectedList.length }}</ng-template>
      <nz-select
        *ngIf="managementDataDataType == 1"
        [(ngModel)]="managementDataHeadhuntingId"
        nzShowSearch
        nzPlaceHolder="请选择猎头"
        class="width-236"
        (click)="managementDataHeadhuntingShow = true"
        nzMode="multiple"
        nzMaxTagCount="2"
        [nzDropdownStyle]="{ display: 'none' }"
        (ngModelChange)="managementDataHeadhuntingIdChange()"
        [nzMaxTagPlaceholder]="tagPlaceHolder6"
      >
        <nz-option *ngFor="let v of headhuntingList" [nzValue]="v.employee_id" [nzLabel]="v.username"></nz-option>
      </nz-select>
      <ng-template #tagPlaceHolder6 let-selectedList>+{{ selectedList.length }}</ng-template>
    </div>
    <div class="ml-md">
      <button nz-button nzType="primary" class="width-74" (click)="managementDataSearchClick()">查询</button>
    </div>
  </div>
  <div></div>
</div>
<div class="mt-xl">
  <div class="border-top-1 border-left-1 border-right-1 d-flex pb-12 pt-12">
    <div class="ml-md"></div>
    <div
      *ngFor="let v of managementDataTypeList"
      (click)="managementDataTypeClick(v.id)"
      class="mr-xxl pointer"
      [ngClass]="{ 'title-active-s': managementDataType == v.id }"
    >
      {{ v.name }}
    </div>
  </div>
  <div>
    <nz-table
      class="min-table border-table table-no-data"
      [nzFrontPagination]="false"
      [nzShowPagination]="false"
      nzBordered
      #tbale3
      [nzData]="managementDataList"
      [nzScroll]="{ x: managementDataTHeadList.length * 120 + 120 + 'px', y: 'auto' }"
    >
      <thead>
        <tr>
          <th nzLeft="0" nzWidth="120px">{{ managementDataDataTypeF == 1 ? '猎头' : '面试官' }}</th>
          <th *ngFor="let v of managementDataTHeadList">{{ v.label_title }}</th>
        </tr>
        <tr>
          <th nzLeft="0">总计</th>
          <th *ngFor="let v of managementDataTotalCount">{{ v }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of tbale3.data">
          <td nzLeft="0">
            <a class="text-primary" (click)="goReason(item)">{{ item.name }}</a>
          </td>
          <td *ngFor="let v of item.arr">{{ v }}</td>
        </tr>
      </tbody>
    </nz-table>
    <div class="d-flex align-items-center justify-content-between bg-gray1 mb-xl" style="height: 32px">
      <div class="text-gray1 ml-md">共 {{ managementDataTotal }} 条数据</div>
      <div class="d-flex align-items-center">
        <nz-pagination
          [(nzPageIndex)]="managementDataPage"
          [nzPageSize]="managementDataPageSize"
          [nzTotal]="managementDataTotal"
          [nzSize]="'small'"
          (nzPageIndexChange)="managementDataPageChange()"
          nzSimple
        ></nz-pagination>
        <nz-select [(ngModel)]="managementDataPageSize" (ngModelChange)="managementDataPageChange()" class="width-84 mr-10" nzSize="small">
          <nz-option [nzValue]="10" nzLabel="10条/页"></nz-option>
          <nz-option [nzValue]="20" nzLabel="20条/页"></nz-option>
          <nz-option [nzValue]="30" nzLabel="30条/页"></nz-option>
          <nz-option [nzValue]="50" nzLabel="50条/页"></nz-option>
        </nz-select>
      </div>
    </div>
  </div>
</div>
<!-- 选择猎头-->
<employee-select
  checkTitle=""
  recommendTitle="猎头"
  [showAll]="false"
  [show]="managementDataHeadhuntingShow"
  [data]="headhuntingList"
  model="admin"
  (sure)="managementDataHeadhuntingSure($event)"
  [checkData]="managementDataHeadhuntingCheckData"
  (cancel)="managementDataHeadhuntingShow = false"
></employee-select>
<!-- 选择面试官-->
<employee-select
  checkTitle=""
  recommendTitle="面试官"
  [showAll]="false"
  [show]="managementDataDunfordShow"
  [data]="interviewerList"
  model="admin"
  (sure)="managementDataDunfordSure($event)"
  [checkData]="managementDataDunfordCheckData"
  (cancel)="managementDataDunfordShow = false"
></employee-select>
